/* The target/designed space arithmetic — one source of truth for the studio
   panel, the client portal and the printable report. Targets come from the
   approved brief; designed figures from the design checklist the studio keeps
   as the scheme develops. */
import type { Project } from "./types";

export interface AuditRow {
  id: string;
  name: string;
  targetQty: number; targetArea: number; targetTotal: number;
  designedQty?: number; designedArea?: number; designedTotal?: number;
  deltaPct?: number;              // designed vs target, in %
  state: "unmeasured" | "ok" | "near" | "off";
}

export function auditRows(p: Project): { rows: AuditRow[]; targetTotal: number; designedTotal: number; measured: number; measuredTargetTotal: number } {
  const items = p.briefChecklist?.items ?? [];
  const rows: AuditRow[] = (p.brief.spaces ?? []).map((s) => {
    const item = items.find((i) => i.spaceId === s.id);
    const targetTotal = s.qty * s.area;
    const dq = item?.designedQty ?? (item?.designedArea != null ? s.qty : undefined);
    const designedTotal = item?.designedArea != null ? (dq ?? s.qty) * item.designedArea : undefined;
    const deltaPct = designedTotal != null && targetTotal > 0 ? ((designedTotal - targetTotal) / targetTotal) * 100 : undefined;
    const state: AuditRow["state"] = deltaPct == null ? "unmeasured" : Math.abs(deltaPct) <= 5 ? "ok" : Math.abs(deltaPct) <= 15 ? "near" : "off";
    return { id: s.id, name: s.name, targetQty: s.qty, targetArea: s.area, targetTotal, designedQty: dq, designedArea: item?.designedArea, designedTotal, deltaPct, state };
  });
  const measuredRows = rows.filter((r) => r.designedTotal != null);
  return {
    rows,
    targetTotal: rows.reduce((n, r) => n + r.targetTotal, 0),
    designedTotal: measuredRows.reduce((n, r) => n + (r.designedTotal ?? 0), 0),
    measured: measuredRows.length,
    measuredTargetTotal: measuredRows.reduce((n, r) => n + r.targetTotal, 0),
  };
}

export const AUDIT_STATE_LABEL: Record<AuditRow["state"], string> = {
  unmeasured: "not measured", ok: "on target", near: "close", off: "off target",
};
